// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_Ey","fallback":"e_Fy","s40":"e_Gy","s32":"e_Hy"};